import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, CommonTextarea, CommonDatePicker } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import ContinuePodRecievedModal from 'modals/ContinuePodRecievedModal';
import moment from 'moment';
import { Images } from 'constants';
import { UserContext } from 'context';
import { IoCloseCircle } from 'react-icons/io5';
import * as Yup from "yup";
import { MdOutlineFileDownload, MdOutlineFileUpload, MdOutlineRemoveRedEye } from 'react-icons/md';
import { FaRegImage } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import ImagePreview from 'modals/LrDetailModal/ImagePreview';
import './podReceive.css';

const formObj = {
    company_id: '',
    lr_id: '',
    date: new Date(),
    pod_number: '',
    notes: '',
    file: [],
};

const PodRecievedModal = (props) => {
    const { masterData, setLrDetialsFrom } = useContext(UserContext)
    const { isOpen, closeModal, nextModal, consignorPermissions, deleteImage } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [imagePreview, setImagePreview] = useState({})

    const addPodReceviedSchema = () => {
        return Yup.object().shape({
            date: Yup.string().required("This filed is Required"),
            file: (consignorPermissions?.permission_at_pod?.attachment?.view === 1 &&
                consignorPermissions?.permission_at_pod?.attachment?.mandatory === 1) ?
                Yup.array()
                    .of(
                        Yup.object().shape({
                            path: Yup.string().required("This filed is Required"),
                        })
                    )
                    .min(1, "At least 1 Attachement Required")
                :
                Yup.array().notRequired(),
            pod_number:
                consignorPermissions?.permission_at_pod?.pod_number?.view === 1 &&
                    consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                    ? Yup.string().min(consignorPermissions?.permission_at_pod?.pod_number?.min ? consignorPermissions?.permission_at_pod?.pod_number?.min : 8, `Must be more than ${consignorPermissions?.permission_at_pod?.pod_number?.min} digit `).max(consignorPermissions?.permission_at_pod?.pod_number?.max ? consignorPermissions?.permission_at_pod?.pod_number?.max : 12, `Must be less than ${consignorPermissions?.permission_at_pod?.pod_number?.max}`).required("Required * ")
                    : Yup.string().notRequired(),
        });
    };

    const schema = addPodReceviedSchema();

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, schema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, schema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            nextModal(formValue)
            closeModal(false);
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen) {
            setFormValue((s) => ({
                ...s,
                lr_id: isOpen?._id,
                company_id: isOpen?.company_id,
                date: new Date(), // Set date with moment
            }));
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen?.isEdit) {
            setFormValue((s) => ({
                ...s,
                lr_id: isOpen?._id,
                company_id: isOpen?.company_id,
                notes: isOpen?.pod_remark,
                file: isOpen?.pod_file,
                date: moment(isOpen?.pod_date).hours(16).minutes(30).toDate(), // Set date with moment
            }));
        }
    }, [isOpen?.isEdit]);

    // const handleFileChange = async (e) => {
    //     if (e?.target?.files[0]?.type === "application/pdf" || e?.target?.files[0]?.type.startsWith("image/")) {
    //         setLoading(true);
    //         try {
    //             const formData = new FormData();
    //             formData.append("file", e?.target?.files[0]);
    //             const res = await uploadFiles(formData);
    //             if (res?.responseCode === 200) {
    //                 var fileArray = []
    //                 fileArray.push(...formValue?.file, { filename: res?.data?.filename, path: res?.data?.path });
    //                 handleOnChange('file', fileArray)
    //                 // setFormValue((s) => ({ ...s, file: fileArray }));
    //                 e.target.value = '';
    //             } else {
    //                 e.target.value = '';
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             e.target.value = '';
    //             setLoading(false);
    //         }
    //     } else {
    //         e.target.value = '';
    //         toast.error("Invalid file, choose images or pdf only");
    //     }
    // }

    const handleFileChange = async (e) => {
        const file = e?.target?.files[0];

        if (!file) return;

        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("file", file);
                const res = await uploadFiles(formData);

                if (res?.responseCode === 200) {
                    const fileArray = [
                        ...(formValue?.file || []),
                        {
                            filename: res?.data?.filename,
                            path: res?.data?.path
                        }
                    ];
                    handleOnChange('file', fileArray);
                    setLoading(false);

                    e.target.value = '';
                } else {
                    setLoading(false);
                    e.target.value = '';
                }
            } catch (error) {
                setLoading(false);
                e.target.value = '';
            }
        } else {
            toast.error("Invalid file, choose images or pdf only");
            e.target.value = '';
        }
    }

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        modalZIndex: imagePreview?.preview && -1,
        onSubmit: handleClick,
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(
                0,
                object.target.maxLength
            );
        }
    };

    const handleDeleteImage = async (item) => {
        let images = [...formValue?.file];
        let newArray = images.filter((el) => el?.path != item?.path)

        deleteImage(item);

        setFormValue((s) => ({
            ...s,
            file: newArray,
        }))
    }

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        modalZIndex: 999999,
        closeModal: (e) => setImagePreview(false),
    }

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            {/* <CommonInput
                                type="date"
                                label='POD Received Date & Time * '
                                placeholder='POD Received Date & Time * '
                                name='date'
                                value={formValue.date}
                                focus={!!(typeof formError === "object" && formError?.date)}
                                error={!!(typeof formError === "object") ? formError?.date : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            /> */}
                            <CommonDatePicker
                                label={'POD Received Date & Time * '}
                                name='date'
                                startDate={formValue.date}
                                setStartDate={(date) => handleOnChange('date', date)}
                                error={!!(typeof formError === "object") ? formError?.date : ""}
                            />
                        </div>

                        {consignorPermissions?.permission_at_pod?.pod_number?.view === 1 && (
                            <div className="singleDiv">
                                <CommonInput
                                    type={consignorPermissions?.permission_at_pod?.pod_number?.field_type === 2 ? "number" : "text"}
                                    label={
                                        consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name} *`
                                                : "POD Number *"
                                            : consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name}`
                                                : "POD Number "
                                    }
                                    placeholder={
                                        consignorPermissions?.permission_at_pod?.pod_number?.mandatory === 1
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name} *`
                                                : "POD Number *"
                                            : consignorPermissions?.permission_at_pod?.pod_number?.field_name
                                                ? `${consignorPermissions?.permission_at_pod?.pod_number?.field_name}`
                                                : "POD Number "
                                    }
                                    min={consignorPermissions?.permission_at_pod?.pod_number?.min ? consignorPermissions?.permission_at_pod?.pod_number?.min : ""}
                                    max={consignorPermissions?.permission_at_pod?.pod_number?.max ? consignorPermissions?.permission_at_pod?.pod_number?.max : ""}
                                    maxLength={
                                        consignorPermissions?.permission_at_pod?.pod_number?.max
                                            ? consignorPermissions?.permission_at_pod?.pod_number?.max
                                            : "12"
                                    }
                                    onInput={maxLengthCheck}
                                    name="pod_number"
                                    value={formValue.pod_number}
                                    // disabled={consignorPermissions?.permission_at_pod?.pod_number?.view === 1 && consignorPermissions?.permission_at_pod?.pod_number?.mandatory !== 1}
                                    focus={
                                        !!(
                                            typeof formError === "object" &&
                                            formError?.pod_number
                                        )
                                    }
                                    error={
                                        !!(typeof formError === "object")
                                            ? formError?.pod_number
                                            : ""
                                    }
                                    onChange={({ target: { name, value } }) =>
                                        handleOnChange(name, value)
                                    }
                                />
                            </div>
                        )}

                        <div className='singleDiv'>
                            <CommonTextarea
                                type="textarea"
                                label="Notes "
                                placeholder="Notes "
                                name='notes'
                                maxLength="500"
                                onInput={utils.maxLengthCheck}
                                value={formValue.notes}
                                focus={!!(typeof formError === "object" && formError?.notes)}
                                error={!!(typeof formError === "object") ? formError?.notes : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>
                        {(consignorPermissions?.permission_at_pod?.attachment?.view === 1) ?
                            < div className='singleDiv'>
                                <div className='_flUpload __podFileUpload'>
                                    <input
                                        type="file"
                                        name='file'
                                        id='_file'
                                        hidden
                                        disabled={loading || formValue?.file?.length >= 5}
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    <label htmlFor='_file'>
                                        <div className='__uploadIcon'>
                                            <MdOutlineFileUpload />
                                        </div>
                                        <div>
                                            <p>Drag and drop files here, or click to browse</p>
                                            <span>Supports PDF, JPG, PNG files up to 10MB each</span>
                                            <div className='_choseBtn'>Choose File</div>
                                        </div>
                                    </label>
                                </div>
                                {formError?.file && (
                                    <span className="input_drop_error">
                                        {formError?.file}
                                    </span>
                                )}
                            </div> : <></>
                        }
                        {(consignorPermissions?.permission_at_pod?.attachment?.view === 1) &&
                            <div className='img_fnex_src'>
                                {
                                    formValue?.file?.length > 0 &&
                                    formValue?.file?.map((el) => {
                                        return (
                                            <>
                                                {/* <div className='pos-relative'> */}
                                                {/* <img className='_pdfIcon_sigxe'
                                                        src={`${masterData?.s3_url}${el?.path}`}
                                                        alt=""
                                                    /> */}
                                                {/* <span className='_clDel_icon' onClick={(e) => handleDeleteImage(el)}>
                                                        <IoCloseCircle />
                                                    </span> */}
                                                <div className='__upFileDetail'>
                                                    <div className='__uplImg'>
                                                        {/* <span className='__uplImg-ct'><FaRegImage /></span> */}
                                                        {
                                                            el?.path?.split('.')?.at(-1) === 'pdf' ?
                                                                <span className='pdf_clsr-ct'>
                                                                    <BsFillFileEarmarkPdfFill />
                                                                </span>
                                                                : (el?.path?.split('.')?.at(-1) === 'xlsx' || el?.path?.split('.')?.at(-1) === 'xls' || el?.path?.split('.')?.at(-1) === 'txt') ?
                                                                    <span className='xlsx_clsr-ct'>
                                                                        <BsFiletypeXlsx />
                                                                    </span> :
                                                                    <span className='__uplImg-ct'>
                                                                        <FaRegImage />
                                                                    </span>
                                                        }
                                                        <p>{`${el?.filename}`}</p>
                                                    </div>
                                                    <div className='__uplIcons _avPointer'>

                                                        <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${el?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />

                                                        <a href={`${masterData?.s3_url}${el?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                                            <MdOutlineFileDownload />
                                                        </a>
                                                        <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => handleDeleteImage(el)}>
                                                            <RxCross2 />
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </>
                                        )
                                    })
                                }
                            </div>
                        }
                        {/* <div>
                            <div>
                                <ul
                                    className={formValue?.file?.length > 0 ? "_attachedFile_bx" : "_withOutAttach_bx"}
                                >
                                    {
                                        formValue?.file ? (
                                            <li>
                                                <span
                                                    className='_delAttach' onClick={(e) => setFormValue((s) => ({...s, file:[]}))}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path d="M6 0C2.65714 0 0 2.65714 0 6C0 9.34286 2.65714 12 6 12C9.34286 12 12 9.34286 12 6C12 2.65714 9.34286 0 6 0ZM8.31429 9L6 6.68571L3.68571 9L3 8.31429L5.31429 6L3 3.68571L3.68571 3L6 5.31429L8.31429 3L9 3.68571L6.68571 6L9 8.31429L8.31429 9Z" fill="black" />
                                                    </svg>
                                                </span>
                                                {attachments?.type === 'application/pdf' ? (
                                                    <img className='_pdfIcon'
                                                        src={Images.PDFICON}
                                                        alt=""
                                                    />
                                                ) : (
                                                    <img
                                                        src={(attachments?.name && URL?.createObjectURL(attachments)) ? URL?.createObjectURL(attachments) : ''}
                                                        alt=""
                                                    />
                                                )}
                                            </li>
                                        ) : <></>
                                    }
                                </ul>
                            </div>
                        </div> */}

                    </div>
                </div>
            </CommonModal >
            <div className='offBack_drop'></div>

            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }
        </div >
    )
}

export default PodRecievedModal
